<main *ngIf="data" class="everest-plus-page">
	<!-- Hero -->
	<section
		class="everest-plus-hero"
		[ngClass]="{ 'bg-blue-dark': slug === 'everest-foz' }"
		*ngIf="data.hero_image || data.hero_title || data.hero_description"
	>
        <div class="content">
            <img
                *ngIf="data.hero_image?.url"
                class="everest-plus-hero__image"
                [src]="data.hero_image.url"
                [alt]="data.hero_image.alt || ''"
            />

            <div class="container everest-plus-hero__content">
                <div class="everest-plus-hero__text">
                    <h1
                        *ngIf="data.hero_title"
                        class="everest-plus-hero__title"
                        [innerHTML]="data.hero_title"
                    ></h1>

                    <div
                        *ngIf="data.hero_description"
                        class="everest-plus-hero__description"
                        [innerHTML]="data.hero_description"
                    ></div>

                    <a
                        *ngIf="data.hero_cta_label && data.hero_cta_link"
                        class="everest-plus-hero__button ga-authorized"
						(click)="scrollToForm($event)"
						[href]="data.hero_cta_link"
						[target]="data.hero_cta_link ? '_blank' : '_self'"
						[ngClass]="{
							'ga-to-know': slug === 'everest-foz',
							'ga-authorized': slug === 'inverter-plus'
						}"
                    >
                        {{ data.hero_cta_label }}
                    </a>
                </div>
            </div>

        </div>
	</section>

	<!-- Intro -->
	<section
		class="everest-plus-intro"
		id="content"
		*ngIf="
			data.intro_main_image ||
			data.intro_title ||
			data.intro_description ||
			data.inverter_intro_details?.length
		"
	>
		<div class="container everest-plus-intro__content">
			<div class="everest-plus-intro__mobile-header">
				<h2
					*ngIf="data.intro_title"
					class="everest-plus-intro__title"
					[innerHTML]="data.intro_title"
				></h2>

				<div
					*ngIf="data.intro_description"
					class="everest-plus-intro__description"
					[innerHTML]="data.intro_description"
				></div>
			</div>

			<img
				*ngIf="data.intro_main_image?.url"
				class="everest-plus-intro__image"
				[src]="data.intro_main_image.url"
				[alt]="data.intro_main_image.alt || ''"
			/>

			<div class="everest-plus-intro__text">
				<h2
					*ngIf="data.intro_title"
					class="everest-plus-intro__title"
					[innerHTML]="data.intro_title"
				></h2>

				<div
					*ngIf="data.intro_description"
					class="everest-plus-intro__description"
					[innerHTML]="data.intro_description"
				></div>

				<div
					class="everest-plus-intro__details"
					*ngIf="data.inverter_intro_details?.length"
				>
					<article
						class="everest-plus-intro__detail"
						*ngFor="let detail of data.inverter_intro_details"
					>
						<img
							*ngIf="detail.image?.url"
							class="everest-plus-intro__detail-icon"
							[src]="detail.image.url"
							[alt]="detail.image.alt || ''"
						/>

						<div class="everest-plus-intro__detail-text">
							<h3
								*ngIf="detail.title"
								class="everest-plus-intro__detail-title"
								[innerHTML]="detail.title"
							></h3>
							<div
								*ngIf="detail.description"
								class="everest-plus-intro__detail-description"
								[innerHTML]="detail.description"
							></div>
						</div>
					</article>
				</div>
			</div>
		</div>
	</section>

	<!-- Topics -->
	<section
		class="everest-plus-topics"
		[ngClass]="{ 'foz': slug === 'everest-foz' }"
		*ngIf="
			data.topics_title ||
			data.topics_description ||
			data.inverter_topics?.length
		"
	>
		<div 
			class="container everest-plus-topics__content"
			
		>
			<div class="everest-plus-topics__header">
				<h2
					*ngIf="data.topics_title"
					class="everest-plus-topics__title"
					[innerHTML]="data.topics_title"
				></h2>

				<div
					*ngIf="data.topics_description"
					class="everest-plus-topics__description"
					[innerHTML]="data.topics_description"
				></div>
			</div>

			<div
				class="everest-plus-topics__list"
				*ngIf="data.inverter_topics?.length"
			>
				<article
					class="everest-plus-topics__item"
					*ngFor="let topic of data.inverter_topics"
				>
					<h3
						*ngIf="topic.title"
						class="everest-plus-topics__item-title"
						[innerHTML]="topic.title"
					></h3>
					<div
						*ngIf="topic.description"
						class="everest-plus-topics__item-description"
						[innerHTML]="topic.description"
					></div>
				</article>
			</div>
		</div>
	</section>

    <section class="everest-text" >
        <div class="container">
            <p *ngIf="slug !== 'everest-foz'">*Economia de 70% baseada em testes de eficiência energética INMETRO, comparando o modelo Everest Plus. O percentual de economia de energia varia de acordo com as condições de uso do aparelho.</p>
        </div>
    </section>

	<!-- Features -->
	<section
		class="everest-plus-features"
		*ngIf="data.inverter_features?.length"
	>
		<div class="container everest-plus-features__list">
			<article
				class="everest-plus-features__item"
				*ngFor="let feature of data.inverter_features"
			>
				<h2
					*ngIf="feature.title"
					class="everest-plus-features__title"
					[innerHTML]="feature.title"
				></h2>
				<div
					*ngIf="feature.description"
					class="everest-plus-features__description"
					[innerHTML]="feature.description"
				></div>

				<img
					*ngIf="feature.image?.url"
					class="everest-plus-features__image"
					[src]="feature.image.url"
					[alt]="feature.image.alt || ''"
				/>
			</article>
		</div>
	</section>

	<!-- Highlights -->
	<section
		class="everest-plus-highlights"
		*ngIf="data.inverter_highlights?.length"
		[ngClass]="{ 'foz': slug === 'everest-foz' }"
	>
		<div class="container everest-plus-highlights__list">
			<article
				class="everest-plus-highlights__item"
				[ngClass]="'everest-plus-highlights__item--' + (index + 1)"
				*ngFor="let highlight of data.inverter_highlights; let index = index"
			>
				<img
					*ngIf="highlight.image?.url"
					class="everest-plus-highlights__image"
					[src]="highlight.image.url"
					[alt]="highlight.image.alt || ''"
				/>

				<div class="everest-plus-highlights__text">
					<h2
						*ngIf="highlight.title"
						class="everest-plus-highlights__title"
						[innerHTML]="highlight.title"
					></h2>
					<div
						*ngIf="highlight.description"
						class="everest-plus-highlights__description"
						[innerHTML]="highlight.description"
					></div>
				</div>
			</article>
		</div>
	</section>

	<!-- Final CTA -->
	<section
		class="everest-plus-cta"
		*ngIf="data.cta_image || data.cta_title || data.cta_description"
	>
		<div class="container everest-plus-cta__content">
			<div class="everest-plus-cta__text">
				<h2
					*ngIf="data.cta_title"
					class="everest-plus-cta__title"
					[innerHTML]="data.cta_title"
				></h2>
				<div
					*ngIf="data.cta_description"
					class="everest-plus-cta__description"
					[innerHTML]="data.cta_description"
				></div>

				<a
					*ngIf="data.cta_button_label && data.cta_button_link"
					class="everest-plus-cta__button"
					[href]="data.cta_button_link"
					[ngClass]="{
							'ga-buy-now': slug === 'everest-foz',
							'ga-authorized': slug === 'inverter-plus'
						}"
				>
					{{ data.cta_button_label }}
				</a>
			</div>

			<img
				*ngIf="data.cta_image?.url"
				class="everest-plus-cta__image"
				[src]="data.cta_image.url"
				[alt]="data.cta_image.alt || ''"
			/>
		</div>
	</section>
</main>
